import { useEffect, useRef } from "react";
import { gsap } from "gsap";

export default function CursorGSAP() {
  const innerRef = useRef(null);
  const outerRef = useRef(null);

  useEffect(() => {
    const inner = innerRef.current;
    const outer = outerRef.current;

    // Hide cursor on touch devices
    const isTouch = "ontouchstart" in window;
    if (isTouch) {
      inner.style.display = "none";
      outer.style.display = "none";
      return;
    }

    // Initial placement
    gsap.set([inner, outer], { x: window.innerWidth / 2, y: window.innerHeight / 2 });

    // Move handler
    const onMove = (e) => {
      const x = e.clientX;
      const y = e.clientY;

      // Inner dot follows instantly
      gsap.to(inner, { x, y, duration: 0.1, ease: "power3.out" });

      // Outer circle lags behind
      gsap.to(outer, { x, y, duration: 0.35, ease: "power3.out" });
    };

    // Hover enlarge when on interactive elements
    const onHover = () => gsap.to(outer, { scale: 1.6, duration: 0.25, ease: "expo.out" });
    const onLeave = () => gsap.to(outer, { scale: 1, duration: 0.25, ease: "expo.out" });

    const interactives = document.querySelectorAll("a, button, input, textarea, [data-hover]");

    interactives.forEach((el) => {
      el.addEventListener("mouseenter", onHover);
      el.addEventListener("mouseleave", onLeave);
    });

    // Click pop effect
    const onClick = () => {
      gsap.fromTo(
        inner,
        { scale: 0.6 },
        { scale: 1, duration: 0.2, ease: "power3.out" }
      );
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("click", onClick);

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("click", onClick);
      interactives.forEach((el) => {
        el.removeEventListener("mouseenter", onHover);
        el.removeEventListener("mouseleave", onLeave);
      });
    };
  }, []);

  return (
    <>
      {/* Outer circle */}
      <div
        ref={outerRef}
        style={{
          width: 36,
          height: 36,
          borderRadius: "50%",
          border: "1px solid #fff",
          background: "#ffffff7a",
          position: "fixed",
          top: 0,
          left: 0,
          pointerEvents: "none",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
        }}
      />

      {/* Inner dot */}
      <div
        ref={innerRef}
        style={{
          width: 8,
          height: 8,
          background: "#c73d3b",
          borderRadius: "50%",
          position: "fixed",
          top: 0,
          left: 0,
          pointerEvents: "none",
          transform: "translate(-50%, -50%)",
          zIndex: 10000,
        }}
      />
    </>
  );
}
